"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var components_1 = require("../../../../components");
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Tabs_1 = require("../../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../../TextArea"));
var Fields_1 = require("../Fields");
exports.errorKeys = [
    'water_advice',
    'water_advice_other',
    'water_action',
    'water_action_other',
    'fuel_debt',
    'water_debt',
    'cause_of_debt',
    'advice_given',
    'water_advice',
];
var WaterSureForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = context_1.useSemantics(), trans = _m.trans, options = _m.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _o = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.watersure) || {}), formErrors = _o[0], setFormErrors = _o[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.watersure) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.watersure]);
    return (react_1.default.createElement(components_1.Card, { heading: trans('project:slhh::headings.watersure'), subHeading: trans('project:slhh::headings.slhh') },
        react_1.default.createElement(Fields_1.WaterAdviceInput, null),
        react_1.default.createElement(Fields_1.WaterActionInput, null),
        react_1.default.createElement(components_1.FormControl, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.watersure) === null || _e === void 0 ? void 0 : _e.fuel_debt, label: trans('project:slhh::labels.fuel-debt') },
            react_1.default.createElement(components_1.Input, { fast: true, width: "xs", name: "project.watersure.fuel_debt", maxLength: 200 })),
        react_1.default.createElement(components_1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.watersure) === null || _g === void 0 ? void 0 : _g.water_debt, label: trans('project:slhh::labels.water-debt') },
            react_1.default.createElement(components_1.Input, { fast: true, width: "xs", name: "project.watersure.water_debt", maxLength: 200 })),
        react_1.default.createElement(components_1.FormControl, { errors: (_j = (_h = errors.project) === null || _h === void 0 ? void 0 : _h.watersure) === null || _j === void 0 ? void 0 : _j.cause_of_debt, label: trans('project:slhh::labels.cause-of-debt') },
            react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.watersure.cause_of_debt", maxLength: 1500 })),
        react_1.default.createElement(components_1.FormControl, { errors: (_l = (_k = errors.project) === null || _k === void 0 ? void 0 : _k.watersure) === null || _l === void 0 ? void 0 : _l.advice_given, label: trans('project:slhh::labels.debt-advice-given'), flush: true },
            react_1.default.createElement(components_1.Select, { width: "xs", options: options.boolean(), name: "project.watersure.advice_given" }))));
};
exports.default = WaterSureForm;
//# sourceMappingURL=WaterSureForm.js.map